<template>
    <div>
        <loading-container v-if="loading"/>

        <div v-else>
            <headline-container :headline="portal.attributes.name" :breadcrumbs="breadcrumbs">
                <select-widget
                    v-model="language"
                    :options="languages.map(language => ({value: language.id, label: language.attributes.name}))"
                    style="margin-top: 13px;"
                />
            </headline-container>

            <div class="container">
                <div class="row">
                    <div class="col-xs-6">
                        <help-text>
                            <h3>
                                Pages
                            </h3>

                            <p>
                                This list displays the pages that exist in the marketing site for the chosen
                                language.
                            </p>

                            <button
                                type="button"
                                class="btn btn-black btn-sm"
                                data-toggle="modal"
                                data-target="#create-marketing-site-page-modal"
                            >
                                <i class="fa fa-plus"></i> New
                            </button>
                        </help-text>
                    </div>

                    <div class="col-xs-18">
                        <page-list-panel :portal="portal" :language="language"/>
                    </div>
                </div>

                <hr class="panel-separator">

                <div class="row">
                    <div class="col-xs-6">
                        <help-text>
                            <h3>
                                Top Menu Items
                            </h3>

                            <p>
                                This list displays the top menu items that exist in the marketing site for the
                                chosen language.
                            </p>

                            <button
                                type="button"
                                class="btn btn-black btn-sm"
                                data-toggle="modal"
                                data-target="#create-marketing-site-top-menu-item-modal"
                            >
                                <i class="fa fa-plus"></i> New
                            </button>
                        </help-text>
                    </div>

                    <div class="col-xs-18">
                        <top-menu-item-list-panel :portal="portal" :language="language"/>
                    </div>
                </div>

                <hr class="panel-separator">

                <div class="row">
                    <div class="col-xs-6">
                        <help-text>
                            <h3>
                                Bottom Menu Items
                            </h3>

                            <p>
                                This list displays the bottom menu items that exist in the marketing site for
                                the
                                chosen language.
                            </p>

                            <button
                                type="button"
                                class="btn btn-black btn-sm"
                                data-toggle="modal"
                                data-target="#create-marketing-site-bottom-menu-item-modal"
                            >
                                <i class="fa fa-plus"></i> New
                            </button>
                        </help-text>
                    </div>

                    <div class="col-xs-18">
                        <bottom-menu-item-list-panel :portal="portal" :language="language"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import http from '@/http'
import BottomMenuItemListPanel from '@/components/Panels/Administration/MarketingSites/BottomMenuItems/List'
import HeadlineContainer from '@/components/Layout/HeadlineContainer'
import HelpText from '@/components/HelpText'
import LoadingContainer from '@/components/Layout/LoadingContainer'
import PageListPanel from '@/components/Panels/Administration/MarketingSites/Pages/List'
import SelectWidget from '@/vendor/forms/FormGroups/Widgets/Select'
import TopMenuItemListPanel from '@/components/Panels/Administration/MarketingSites/TopMenuItems/List'

export default {
    components: {
        BottomMenuItemListPanel,
        HeadlineContainer,
        HelpText,
        LoadingContainer,
        PageListPanel,
        SelectWidget,
        TopMenuItemListPanel
    },

    props: {
        portalId: {
            required: true
        }
    },

    data() {
        return {
            portal: null,
            languages: null,

            language: null,

            loading: true
        }
    },

    mounted() {
        this.load()
    },

    computed: {
        breadcrumbs() {
            return [
                {url: '/marketing-sites', text: 'Marketing Sites'},
                {text: this.portal.attributes.name}
            ]
        }
    },

    methods: {
        load() {
            Promise.all([
                http.get('/api/v2/portals/' + this.portalId),
                http.get('/api/v2/marketing-site-languages')
            ])
                .then(responses => {
                    this.portal = responses[0].data.data

                    this.languages = responses[1].data.data

                    this.language = this.languages[0].id

                    this.loading = false
                })
        }
    }
}
</script>
